const SESSION_KEY = 'persist:teleconsultation-admin';

const getSession = () => JSON.parse(localStorage.getItem(SESSION_KEY));

export { getSession };
